// noa-price-format.js — render prices as Hebrew "X ש״ח"
(function(){
  function reformat(node) {
    if (!node) return;
    // Walk text nodes only
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null, false);
    var t;
    while ((t = walker.nextNode())) {
      var s = t.nodeValue;
      // Match "NIS 350.00", "350.00 NIS", "₪350.00", "ILS 350.00"
      // Capture integer amount (strip decimals if .00)
      var replaced = s.replace(
        /(?:NIS|ILS|₪)\s*(\d{1,3}(?:[,\d]{0,7})(?:\.\d{1,2})?)/g,
        function(_, n){ return formatIls(n); }
      );
      replaced = replaced.replace(
        /(\d{1,3}(?:[,\d]{0,7})(?:\.\d{1,2})?)\s*(?:NIS|ILS|₪)/g,
        function(_, n){ return formatIls(n); }
      );
      if (replaced !== s) t.nodeValue = replaced;
    }
  }
  function formatIls(numStr) {
    var n = parseFloat(numStr.replace(/,/g, ''));
    if (isNaN(n)) return numStr + ' ש"ח';
    var intPart = (n % 1 === 0) ? n.toFixed(0) : n.toFixed(2).replace(/\.?0+$/, '');
    return intPart + ' ש"ח';
  }
  function run() { reformat(document.body); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  // Also run after variant change / cart updates
  document.addEventListener('variant:change', run); document.addEventListener('change', function(e){ if(e.target && e.target.closest && e.target.closest('.product-form, product-form-component, .variant-option')) run(); });
  document.addEventListener('cart:refresh', run);
  // MutationObserver fallback: any time the DOM changes, reformat the changed subtree
  // Re-run on ANY DOM change incl. text updates (Horizon uses morph() which mutates
  // text nodes in place -> needs characterData, not just childList, to catch cart prices)
  // Reformat SYNCHRONOUSLY inside the observer (microtask -> before paint) so the
  // raw "NIS 350.00" never flashes when a variant/size is changed. Disconnect during
  // reformat to avoid the self-trigger loop, then reconnect.
  var moOpts = { childList: true, subtree: true, characterData: true };
  var mo = new MutationObserver(function(mutations){
    mo.disconnect();
    for (var i = 0; i < mutations.length; i++) {
      var tgt = mutations[i].target;
      if (tgt && tgt.nodeType === 3) tgt = tgt.parentNode;
      reformat(tgt || document.body);
    }
    if (document.body) mo.observe(document.body, moOpts);
  });
  if (document.body) mo.observe(document.body, moOpts);
  ['cart:updated','cart:change','cart:refresh','dialog:open'].forEach(function(ev){
    document.addEventListener(ev, function(){ setTimeout(run, 50); });
  });
})();
